import React, { useContext, useRef, useState } from 'react';
import {
    Dropdown,
  } from "@fluentui/react";
import studylistContext from '../../../../../context/studylist/StudylistContext';
import { NO_OF_IMAGES_STATUS } from '../../../../../constants/Constants';

const NoOfImageFilter = () => {

    const {
      searchDto,
      setSearchDto,
      handleChangeSizeIndex,
      setFilterApplied,
      filterApplied,
      noOfImagesFilter, setNoOfImagesfilter
    } = useContext(studylistContext);
    const dropdownRef = useRef();

      const dropdownStyles = {
        dropdown: { width: 75, broderRadius: 0 },
        dropdownItemsWrapper :{
          maxHeight:'400px'
      },
        title: {
          //border: "1px solid rgba(200, 198, 196, 0.3)",
          borderRadius: "7px",
          background: "none",
          height: "32px",
          display: "flex",
          alignItem: "center",
        },
        dropdownItems: {
          selectors: {
            "@media(min-width: 640px)": {
              maxHeight: 300,
            },
          },
        },
      };

    const noOfImagesOptionsFunction = () => {
        let options = [
          { key: "", text: "any" },
          { key: NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES, text: "0" },
          { key: NO_OF_IMAGES_STATUS.MORE_THAN_ZERO_NO_OF_IMAGES, text: "> 0"},
        ]
        return options; 
    }

    const handleFilter = (data) => {
        handleChangeSizeIndex(0,50,"");
        setSearchDto({...searchDto, noOfImages: data })
        setNoOfImagesfilter(data);
        let filterUpdated = filterApplied + 1;
        setFilterApplied(filterUpdated);
    };

  return (
    <>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        // width:"20%"
      }}
    >
      <p className="sort-search-text">No Of Images</p>
        <Dropdown
          componentRef={dropdownRef}
          options={noOfImagesOptionsFunction()}
          value={noOfImagesFilter}
          placeholder="Select"
          onChange={(e, data) =>{
            console.log(e, data);
                setNoOfImagesfilter(data.key);
                handleFilter(data.key);
            }
          }
          styles={dropdownStyles}
          defaultSelectedKey={noOfImagesFilter}
        />
    </div>
  </>
  )
}

export default NoOfImageFilter